import { faFlag, faIndustryWindows } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCustomTranslation } from '../../../../../../../../hooks/useCustomTranslation';
import { faFlag as faFlagSolid } from '@fortawesome/pro-solid-svg-icons';
import { useGetGraphneSimulationLots, useSimulationLazyLoading } from '../../../../hooks';
import { SimulationLotSummarySkeleton } from '.';
import { TaskView } from '@nexelem/graphne-api';
import clsx from 'clsx';

type SimulationLotSummaryItemProps = {
  task: TaskView;
};

const SimulationLotSummaryItem = ({ task }: SimulationLotSummaryItemProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  const productDetailsCode = task.productDetails.code.split(' ');
  const [productCode, ...productOperations] = productDetailsCode;

  return (
    <div className="flex items-center gap-2 rounded-xs border border-border-container p-2">
      <FontAwesomeIcon
        className={clsx('!h-6 w-8.5', task.priority ? 'text-icon-brand' : 'text-icon-primary')}
        icon={task.priority ? faFlagSolid : faFlag}
      />

      <FontAwesomeIcon
        className="min-h-5 w-5 rounded-full border border-border-container bg-surface-container-lighter p-1"
        icon={faIndustryWindows}
      />
      <div className="flex flex-col gap-0.5">
        <p className="inline-flex gap-2 text-s11-sb uppercase">
          {tWrapper('taskItemProductNumber')} <span>{productCode}</span>
        </p>
        <p className="text-s16-sb">{task.productDetails.name}</p>
        <p className="inline-flex gap-2 text-s11-sb uppercase">{productOperations.join(' ')}</p>
      </div>
      <div className="ml-auto text-s18">{task.progress.totalAmount.amount}</div>
      <div className="w-20 text-s18 text-text-secondary-darker">{task.progress.totalAmount.unit.name}</div>
    </div>
  );
};

export const SimulationLotSummary = () => {
  const { data = [], isLoading, fetchNextPage, hasNextPage } = useGetGraphneSimulationLots();
  const { lastItemRef, shouldShowSkeletons } = useSimulationLazyLoading({
    hasNextPage,
    isLoading,
    fetchNextPage,
  });

  if (isLoading) {
    return <SimulationLotSummarySkeleton />;
  }

  return (
    <div className="flex max-h-65 flex-col gap-3 overflow-auto">
      {data.map((task, index) => {
        const isLastItem = index === data.length - 1;

        return (
          <div key={task.id} ref={isLastItem ? lastItemRef : undefined}>
            <SimulationLotSummaryItem task={task} />
          </div>
        );
      })}
      {shouldShowSkeletons && <SimulationLotSummarySkeleton count={2} />}
    </div>
  );
};
